// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

const Wrapper = styled.span`
  ${({ $color }) => css`
    color: ${$color};
  `}
`;

type BoomNavLabelProps = {
  className?: string;
  color: string;
};

const BoomNavLabel = ({ className = '', color }: BoomNavLabelProps) => {
  return (
    <Wrapper className={className} $color={color}>
      Boom
    </Wrapper>
  );
};

export default BoomNavLabel;
